import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import api, { baseURL } from '../../../services/api'
import { useEditEvent } from '../../../contexts/editEvent.context'
import { useNavigation } from '../../../contexts/navigation.context'
import { useAuth } from '../../../contexts/auth.context'

import {
    Box, Button, Grid, TextField,
    FormControlLabel, FormGroup, Typography,
    Switch, Autocomplete, IconButton, ListItemIcon,
    ListItemButton, ListItemText, List, ListItem,
    Snackbar, CircularProgress, Checkbox,
    Dialog, DialogContent, DialogActions,
    DialogTitle, FormControl, InputLabel,
    Select, MenuItem,
} from '@mui/material'
import { green } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert'
import Add from '@mui/icons-material/Add'
import Edit from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete'
import * as yup from 'yup';
import { useFormik } from 'formik';
import IntlCurrencyInput from "react-intl-currency-input"
import { parseISO, format, areIntervalsOverlapping, addDays } from 'date-fns';


const Information = () => {
    const pricechange = useRef(0);
    const typechange = useRef();
    const planDueDateChange = useRef('');
    const [newPlanDueDate, setNewPlanDueDate] = useState('');
    const hosting_type = useRef();
    const hosting_price = useRef();
    const hosting_name = useRef();
    const hosting_status = useRef();
    const hosting_vacancies = useRef();
    const collect_start = useRef();
    const collect_finish = useRef();
    const credit = useRef(0);
    const planName = useRef();
    const planChange = useRef();
    const [planDialog, setplanDialog] = useState(false);
    const { activeStep, setActiveStep, setEventDTO, eventDTO } = useEditEvent();
    const [insertTypes, setInsertTypes] = useState([]);
    const [insertCollectors, setInsertCollectors] = useState([]);
    const [insertHostings, setInsertHostings] = useState([]);
    const navigate = useNavigate();
    const navigation = useNavigation();
    const { basePath } = useAuth();
    const [loadingCertificate, setLoadingCertificate] = React.useState(false);
    const [loadingImage, setLoadingImage] = React.useState(false);
    const [certificateFile, setCertificateFile] = React.useState(null);
    const [speakerCertificateFile, setSpeakerCertificateFile] = React.useState(null);
    const [thumbnailFile, setThumbnailFile] = React.useState(null);
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const [previewUrl, setPreviewUrl] = React.useState(null);
    const [previewTitle, setPreviewTitle] = React.useState('');
    const [stateAlert, setStateAlert] = React.useState({ status: false, type: 'success', msg: '' });
    const [editVagasDialog, setEditVagasDialog] = useState(false);
    const [hostingEdit, setHostingEdit] = useState(null);
    const [vagasEditValue, setVagasEditValue] = useState(0);
    const validationInformation = yup.object({
        name: yup
            .string('Insira o nome do Evento')
            .required('Campo necessário'),
        isActive: yup
            .boolean()
            .required('Campo necessário'),
        typeForm: yup
            .string()
            .oneOf(['subscriber', 'company', 'auto'])
            .default('company'),
        isInstallments: yup
            .boolean()
            .default(false)
            .nullable(),
        isCourse: yup
            .boolean()
            .default(false)
            .nullable(),
        start_subscription: yup
            .date()
            .required('Campo necessário'),
        end_subscription: yup
            .date()
            .min(yup.ref('start_subscription'), 'A data deve ser maior que a data de inicio das incrições')
            .max(yup.ref('date_initial'), 'A data deve ser menor que o inicio do evento')
            .required('Campo necessário'),
        max_subscribers: yup
            .number('Campo deve ser do tipo numero')
            .positive('Deve ser um numero maior que zero')
            .typeError('Somente números')
            .required('Campo necessário'),
        certificate: yup
            .mixed('Envie o template do certificado')
            .required('Campo necessário'),
        speakerCertificate: yup
            .mixed()
            .nullable(),
        payment_options: yup
            .object()
            .required('Opções de pagamento necessária'),
        due_date: yup
            .number()
            .positive('Deve ser um numero maior que zero')
            .typeError('Somente números')
            .min(2, 'O vencimento mínimo é de 2 dias')
            .max(30, 'O vencimento máximo é de 30 dias')
            .required('Vencimento do boleto necessário'),
        plans: yup
            .array()
            .min(1, 'Tipos de Inscrições Necessárias')
            .required('Tipos de insrição necessário'),
        hostings: yup
            .array(),
        collectors: yup
            .array(),
        date_initial: yup
            .date()
            .typeError('Data inválida')
            .min(yup.ref('end_subscription'), 'A data deve ser maior que a data de inicio das incrições')
            .required('Campo necessário'),
        date_finish: yup
            .date()
            .typeError('Data inválida')
            .min(yup.ref('date_initial'), 'A data deve ser maior que a data de inicio do evento')
            .required('Campo necessário'),
        thumbnail: yup
            .mixed('Envie a imagem do evento')
            .required('Campo necessário'),
        city: yup
            .string('Insira a cidade do evento')
            .required('Campo necessário'),
        uf: yup
            .string('Insira a UF ')
            .required('Campo necessário'),
        counter_hostings: yup
            .object()
            .default({})
            .optional(),
    });

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
            number: {
                BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                },
            },
        },
    };

    useEffect(() => {
        let loaded = false
        console.log(eventDTO !== null)
        console.log(formik.values)
        if (!loaded && eventDTO !== null) {
            if (formik.values.payment_options == null) {
                formik.setFieldValue('payment_options', { "Pix": true, "Boleto": true, "Transação ou Depósito Bancário": false, "Nota de empenho/depósito bancário": false })
                formik.setFieldValue('due_date', 15)
            }
            handlePlans()
            handleHostings()
            handleCollectors()
            loaded = true
        }
        return () => {
            //formik.handleReset()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function handlePlans() {
        let types = eventDTO.plans
        let ids = []
        if (Object.keys(types).length > 0) {
            for await (const plan of types) {
                let id = plan.id === undefined ? plan : plan.id
                ids.push(id)
                if (insertTypes.find(plano => plano.id === id)) {
                    return
                } else {
                    const loadPlans = await api.get('/plans/' + id)
                    if (loadPlans.status === 200) {
                        setInsertTypes(prev => [...prev, loadPlans.data.data])
                    }
                }
            }
            formik.setFieldValue('plans', ids)
            setEventDTO({ ...eventDTO, plans: ids })

        }
    };

    async function handleCollectors() {
        let collects = eventDTO.collectors
        let ids = []
        if (Object.keys(collects).length > 0) {
            for await (const collector of collects) {
                let id = collector.id === undefined ? collector : collector.id
                ids.push(id)
                if (insertCollectors.find(col => col.id === id)) {
                    return
                } else {
                    const loadCollectors = await api.get('/collectors/' + id)
                    if (loadCollectors.status === 200) {
                        setInsertCollectors(prev => [...prev, loadCollectors.data.data])
                    }
                }
            }
            formik.setFieldValue('collectors', ids)
            setEventDTO({ ...eventDTO, collectors: ids })
        }
    };
    const defaultInitialValues = {
        name: '',
        isActive: true,
        isVisible: true,
        isControlCompany: false,
        typeForm: 'company',
        isInstallments: false,
        isCourse: false,
        start_subscription: '',
        end_subscription: '',
        max_subscribers: '',
        certificate: '',
        speakerCertificate: null,
        payment_options: { "Pix": true, "Boleto": true, "Transação ou Depósito Bancário": true, "Nota de Empenho": false },
        due_date: 15,
        plans: [],
        hostings: [],
        collectors: [],
        date_initial: '',
        date_finish: '',
        thumbnail: '',
        message_confirmation: '',
        city: '',
        uf: '',
        counter_hostings: {},
    };

    const formik = useFormik({
        initialValues: eventDTO || defaultInitialValues,
        validateOnMount: true,
        validationSchema: validationInformation,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log({ values, activeStep });
            setEventDTO({ ...eventDTO, ...values })
            setActiveStep(activeStep + 1)
        }
    });

    function handleBack() {
        navigation.nextPage("/eventos")
        navigate(-1)
    };

    async function handelDeleteType(id) {
        try {
            const plan = await api.delete("/plans/" + id)
            if (plan.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de inscrição excluído com sucesso!' })
                const newPlan = insertTypes.filter(plans => plans.id !== id)
                if (newPlan.length > 0) {
                    let ids = []
                    for await (const type of newPlan) {
                        ids.push(type.id)
                    }
                    setEventDTO({ ...eventDTO, plans: ids })
                    setInsertTypes([...newPlan])
                    formik.setFieldValue('plans', ids)
                } else {
                    setEventDTO({ ...eventDTO, plans: [] })
                    setInsertTypes([])
                    formik.setFieldValue('plans', [])
                }
            }
        } catch (error) {
            let msg = error.response.data.error.message || 'Erro ao excluir tipo de inscrição!'
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg })
        }
    };

    async function handleDeleteHosting(id) {
        try {
            const hosting = await api.delete("/hostings/" + id)
            if (hosting.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de Hospedagem excluído com sucesso!' })
                const newHosting = insertHostings.filter(host => host.id !== id)
                if (newHosting.length > 0) {
                    let ids = []
                    for await (const type of newHosting) {
                        ids.push(type.id)
                    }
                    const newCounterHostings = { ...formik.values.counter_hostings };
                    // Validação antes do delete
                    if (newCounterHostings.hasOwnProperty(id)) {
                        delete newCounterHostings[id];
                        formik.setFieldValue('counter_hostings', newCounterHostings);
                    }
                    setEventDTO({ ...eventDTO, hostings: ids })
                    setInsertHostings([...newHosting])
                    formik.setFieldValue('hostings', ids)
                } else {
                    setInsertHostings([])
                    formik.setFieldValue('hostings', [])
                }
            }
        } catch (error) {
            let msg = error.response.data.error.message || 'Erro ao excluir tipo de hospedagem!'
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg })
        }
    };

    async function handelDeleteCollect(id) {
        try {
            const collect = await api.delete("/collectors/" + id)
            if (collect.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Períodos de referência para leitura excluído com sucesso!' })
                const newCollect = insertCollectors.filter(coll => coll.id !== id)
                if (newCollect.length > 0) {
                    let ids = []
                    for await (const collector of newCollect) {
                        ids.push(collector.id)
                    }
                    setEventDTO({ ...eventDTO, collectors: ids })
                    setInsertCollectors([...newCollect])
                    formik.setFieldValue('collectors', ids)
                } else {
                    setInsertCollectors([])
                    formik.setFieldValue('collectors', [])
                }
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao excluir período de referência para leitura!' })
        }
    };

    async function handleInformation() {
        try {
            const newEvent = await api.put('/events/' + eventDTO.id, { data: formik.values })
            if (newEvent.status === 200) {
                setActiveStep(7)
            }
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
        }
    };

    async function handelStatusPlan(id) {
        console.log(id)
        console.log(insertTypes.find(plans => id == plans.id).attributes.status)
        try {
            const plan = await api.put("/plans/" + id, { data: { status: !insertTypes.find(plans => plans.id === id).attributes.status } })
            if (plan.status === 200) {
                insertTypes.map(plans => {
                    if (plans.id == id) plans.attributes.status = !plans.attributes.status
                });
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de inscrição alterado com sucesso!' })
            }
        } catch (error) {
            let msg = error.response.data.error.message || 'Erro ao alterar tipo de inscrição!'
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg })
        }
    };
    async function handelStatusHosting(id) {
        console.log(id)
        console.log(insertHostings.find(host => id == host.id).attributes.status)
        console.log(insertHostings.find(host => id == host.id).status)
        try {
            const host = await api.put("/hostings/" + id, { data: { status: !insertHostings.find(host => host.id === id).attributes.status } })
            if (host.status === 200) {
                insertHostings.map(hosts => {
                    if (hosts.id == id) hosts.attributes.status = !hosts.attributes.status
                });
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de hospedagem alterado com sucesso!' })
            }

        } catch (error) {
            let msg = error.response.data.error.message || 'Erro ao alterar tipo de hospedagem!'
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg })
        }

    }

    async function addTypes() {
        let plan = eventDTO.plans
        const types = {
            price: pricechange.current,
            type: typechange.current,
            dueDate: newPlanDueDate || null
        }
        console.log(types)
        try {
            if (types.price === null || types.type == null) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Tipo ou Valor da inscrição é requerido!' })
                return
            }
            if (types.dueDate !== null && types.dueDate < format(new Date(), 'yyyy-MM-dd')) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'A data de vencimento do boleto não pode ser anterior a hoje.' })
                return
            }

            if (plan.length > 0 && plan[0] && Object.keys(plan[0]).length === 0) {
                if (insertTypes.find(types => types.attributes.type === typechange.current)) {
                    setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Tipo de inscrição já adicionada!' })
                    return
                }
            }
            const plans = await api.post("/plans", { data: types })
            if (plans.status === 200) {
                console.log(plans.data.data)
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de inscrição adicionada com sucesso!' })
                setInsertTypes([...insertTypes, plans.data.data])
                typechange.current = null
                pricechange.current = 0
                setNewPlanDueDate('')
                setEventDTO({ ...eventDTO, plans: [...formik.values.plans, plans.data.data.id] })
                formik.setFieldValue('plans', [...formik.values.plans, plans.data.data.id])
                console.log(formik.values)
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao cadastrar tipo de inscrição!' })
        }
    };

    async function addCollectors() {
        const collectors = { "collect_start": collect_start.current, "collect_finish": collect_finish.current, "credit": credit.current }
        console.log(collectors)
        console.log({ start: parseISO(formik.values.date_initial), end: addDays(parseISO(formik.values.date_finish), 1) },
            { start: parseISO(collect_start.current), end: parseISO(collect_finish.current) })
        try {
            if (collectors.collect_start === null || collectors.collect_finish == null || collectors.credit <= 0) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Períodos de referência para leitura é requerido!' })
                return
            } else if (insertCollectors.filter(collect => areIntervalsOverlapping(
                { start: parseISO(collect.attributes.collect_start), end: parseISO(collect.attributes.collect_finish) },
                { start: parseISO(collect_start.current), end: parseISO(collect_finish.current) }
            )).length > 0) {

                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Períodos de coleta já adicionado!' })
                return
            } else if (!areIntervalsOverlapping(
                { start: parseISO(formik.values.date_initial), end: addDays(parseISO(formik.values.date_finish), 1) },
                { start: parseISO(collect_start.current), end: parseISO(collect_finish.current) })
            ) {
                console.log({ start: parseISO(formik.values.date_initial), end: addDays(parseISO(formik.values.date_finish), 1) },
                    { start: parseISO(collect_start.current), end: parseISO(collect_finish.current) })
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Períodos de coleta deve estar dentro do intervalo de datas do evento!' })
                return
            }
            const collectorsEvent = await api.post("/collectors", { data: collectors })
            if (collectorsEvent.status === 200) {
                collect_start.current = ""
                credit.current = ""
                collect_finish.current = ""
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Períodos de referência para leitura adicionada com sucesso!' })
                setInsertCollectors([...insertCollectors, collectorsEvent.data.data])
                formik.values.collectors == undefined ? formik.setFieldValue('collectors', [collectorsEvent.data.data.id]) : formik.setFieldValue('collectors', [...formik.values.collectors, collectorsEvent.data.data.id])
                console.log(formik.values)
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao cadastrar Períodos de referência para leitura!' })
        }
    };

    function handleChangeTypesName(plan) {
        console.log(plan);
        setplanDialog(true);
        planChange.current = plan
        planName.current = plan.attributes.type
        planDueDateChange.current = plan.attributes.dueDate ?? ''
    };

    async function updatePlan(name) {
        console.log(name, planChange.current)
        try {
            const dueDate = planDueDateChange.current || null
            if (dueDate !== null && dueDate < format(new Date(), 'yyyy-MM-dd')) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'A data de vencimento do boleto não pode ser anterior a hoje.' })
                return
            }
            const plan = await api.put("/plans/" + planChange.current.id, { data: { type: name, dueDate } })
            if (plan.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de inscrição alterado com sucesso!' })
                setplanDialog(false)
                setInsertTypes(insertTypes.map(plans => plans.id === planChange.current.id
                    ? { ...plans, attributes: { ...plans.attributes, type: name, dueDate } }
                    : plans))
            }
        } catch (error) {
            console.log(error)
            let msg = 'Erro ao alterar tipo de inscrição!'
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg })
        }

    };

    async function handleUpdateHosting() {
        try {
            if (hostingEdit) {
                const host = await api.put("/hostings/" + hostingEdit.id, {
                    data:
                    {
                        vacancies: hostingEdit.attributes.vacancies,
                        name: hostingEdit.attributes.name,
                    }
                })
                if (host.status === 200) {
                    setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de hospedagem alterado com sucesso!' })
                    insertHostings.map(hosts => {
                        if (hosts.id === hostingEdit.id) {
                            hosts.attributes.vacancies = hostingEdit.attributes.vacancies
                            hosts.attributes.name = hostingEdit.attributes.name

                        }

                    });
                    setEditVagasDialog(false)
                    setHostingEdit(null)
                    setVagasEditValue(0)
                }
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao atualizar tipo de hospedagem!' })
        }
    }
    function handleEditVagas(hosting, vagasAtuais) {
        setHostingEdit(hosting);
        setVagasEditValue(vagasAtuais);
        setEditVagasDialog(true);
    }

    async function addHostings() {
        let hosting = eventDTO.hostings
        const types = { pricebyday: hosting_price.current, type: hosting_type.current, name: hosting_name.current, vacancies: hosting_vacancies.current, status: true }
        console.log(types)
        try {
            if (types.pricebyday === null || types.type == null || types.name == null || types.vacancies == null || types.vacancies <= 0) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Tipo, Valor ou Número de Vagas da hospedagem é requerido!' })
                return
            }
            if (hosting) {
                console.log(insertHostings.find(types => (types.attributes.name === hosting_name.current && types.attributes.type === hosting_type.current)))
                if (insertHostings.find(types => (types.attributes.name === hosting_name.current && types.attributes.type === hosting_type.current))) {
                    const hostId = hostings.data.data.id;
                    console.log(hostId)
                    formik.setFieldValue('counter_hostings', { ...formik.values.counter_hostings, [hostId]: 0 })
                    console.log(formik.values.counter_hostings)
                    hosting_type.current = null
                    hosting_price.current = null
                    hosting_name.current = null
                    hosting_vacancies.current = null
                    document.getElementById('name_hosting').value = '';
                    document.getElementById('name_hosting').innerHTML = '';
                    document.getElementById('hosting_type').innerHTML = '';
                    document.getElementById('hosting_type').value = '';
                    document.getElementById('hosting_price').value = '';
                    document.getElementById('hosting_price').innerHTML = '';
                    document.getElementById('hosting_vacancies').innerHTML = 0;

                    setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Tipo de hospedagem já adicionada!' })
                    return
                }
            }
            const hostings = await api.post("/hostings", { data: types })
            if (hostings.status === 200) {
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: 'Tipo de hospedagem adicionada com sucesso!' })
                setInsertHostings([...insertHostings, hostings.data.data])
                hosting_type.current = null
                hosting_price.current = null
                hosting_name.current = null
                hosting_vacancies.current = null
                formik.values.hostings == undefined ? formik.setFieldValue('hostings', [hostings.data.data.id]) : formik.setFieldValue('hostings', [...formik.values.hostings, hostings.data.data.id])
                document.getElementById('name_hosting').value = '';
                document.getElementById('name_hosting').innerHTML = '';
                document.getElementById('hosting_type').innerHTML = '';
                document.getElementById('hosting_type').value = '';
                document.getElementById('hosting_price').value = '';
                document.getElementById('hosting_price').innerHTML = '';
                document.getElementById('hosting_vacancies').innerHTML = 0;

                setEventDTO({ ...eventDTO, hostings: formik.values.hostings })
                console.log(formik.values)
            }
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao cadastrar tipo de hospedagem!' })
        }
    };

    async function handleHostings() {
        let hostings = eventDTO.hostings
        let ids = []
        let counterHostingsAccumulator = { ...(formik.values.counter_hostings || {}) };
        console.log(hostings)
        if (hostings) {
            for await (const host of hostings) {
                let id = host.id === undefined ? host : host.id
                ids.push(id)
                if (insertHostings.find(host => host.id === id)) {
                    return
                } else {
                    const loadHostings = await api.get('/hostings/' + id)
                    if (loadHostings.status === 200) {
                        counterHostingsAccumulator[id] = loadHostings.data.data.attributes.vacancies;
                        setInsertHostings(prev => [...prev, loadHostings.data.data])
                    }
                }
            }
            formik.setFieldValue('counter_hostings', counterHostingsAccumulator);
            formik.setFieldValue('hostings', ids)
            setEventDTO({ ...eventDTO, hostings: ids })
            console.log(formik.values.hostings)
            console.log('counter', formik.values.counter_hostings, counterHostingsAccumulator)
        }
    }
    const listTypes = ['RPPS associado', 'RPPS de outros Estados', 'RPPS não associado', 'Órgãos Públicos (exceto Instituições Financeiras) ou Entes que não possuem RPPS',
        'Outras Instituições e/ou Prestadores de Serviços', 'Patrocinador']

    async function handleCertificate(event, field) {
        const files = event.target.files
        const formData = new FormData()
        formData.append('files', files[0])
        field === 'doc' ? setLoadingCertificate(true) : setLoadingImage(true)
        try {
            const doc = await api.post('/upload', formData)
            const uploaded = doc.data[0]
            formik.setFieldValue(event.target.name, uploaded.id)
            if (field === 'doc') {
                setCertificateFile(uploaded)
            } else if (field === 'speakerDoc') {
                setSpeakerCertificateFile(uploaded)
            } else {
                setThumbnailFile(uploaded)
            }
            setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `${event.target.name} enviado com sucesso` })
            field === 'doc' ? setLoadingCertificate(false) : setLoadingImage(false)
        } catch (error) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: 'Erro ao enviar!' })
            field === 'doc' ? setLoadingCertificate(false) : setLoadingImage(false)
        }
    };

    function openPreview(file, title) {
        if (!file) return;
        const url = file.url?.startsWith('/') ? `${baseURL}${file.url}` : file.url;
        if (file.mime?.includes('image/')) {
            setPreviewUrl(url);
            setPreviewTitle(title);
            setPreviewOpen(true);
        } else {
            window.open(url, '_blank');
        }
    }

    function closePreview() {
        setPreviewOpen(false);
        setPreviewUrl(null);
        setPreviewTitle('');
    }

    return (
        <>
            <Snackbar
                open={stateAlert.status}
                autoHideDuration={2500}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => setStateAlert({ status: false, type: 'success', msg: '' })} >
                <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                    {stateAlert.msg}
                </Alert>
            </Snackbar>
            <form onSubmit={formik.handleSubmit}>
                <Box pb={2}>
                    <Grid container spacing={2} columns={12} sx={{ mb: 5 }}>
                        <Grid item xs={6}>
                            <TextField sx={{ width: '100%' }}
                                label="Nome do Evento"
                                id='name'
                                focused
                                name="name"
                                variant="outlined"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                                placeholder="Nome do Evento" />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField sx={{ width: '100%' }}
                                label="Máximo de Inscrições"
                                type={'number'}
                                focused
                                name="max_subscribers"
                                id="max_subscribers"
                                variant="outlined"
                                value={formik.values.max_subscribers}
                                onChange={formik.handleChange}
                                error={formik.touched.max_subscribers && Boolean(formik.errors.max_subscribers)}
                                helperText={formik.touched.max_subscribers && formik.errors.max_subscribers}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Box sx={{ m: 1, position: 'relative' }}>
                                <Button variant="contained" component="label" fullWidth disabled={loadingCertificate} >
                                    Certificado
                                    <input
                                        hidden
                                        name="certificate"
                                        type={'file'}
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        label="Template do Certificado"
                                        onChange={(e) => handleCertificate(e, 'doc')}
                                        error={formik.touched.certificate && Boolean(formik.errors.certificate)}
                                        helperText={formik.touched.certificate && formik.errors.certificate}
                                        sx={{ width: '100%' }}
                                        variant="outlined"
                                    />
                                </Button>
                                {loadingCertificate && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: green[500],
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                )}
                            </Box>
                            <Typography variant='caption'>{!!formik.values.certificate ? 'Certificado Cadastrado' : ''}</Typography>
                            {(certificateFile || formik.values.certificate) && (
                                <Button size="small" variant="text" onClick={() => {
                                    const file = certificateFile || (typeof formik.values.certificate === 'object' ? formik.values.certificate : null);
                                    if (file) openPreview(file, 'Pré-visualização do Certificado');
                                }}>
                                    Visualizar certificado
                                </Button>
                            )}
                            <Typography variant='caption' color={"#FF0000"}>{formik.errors.certificate}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Box sx={{ m: 1, position: 'relative' }}>
                                <Button variant="outlined" component="label" fullWidth disabled={loadingCertificate}>
                                    Certificado de Palestrantes
                                    <input
                                        hidden
                                        name="speakerCertificate"
                                        type="file"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        onChange={(e) => handleCertificate(e, 'speakerDoc')}
                                    />
                                </Button>
                                {loadingCertificate && (
                                    <CircularProgress
                                        size={24}
                                        sx={{ color: green[500], position: 'absolute', top: '50%', left: '50%', marginTop: '-12px', marginLeft: '-12px' }}
                                    />
                                )}
                            </Box>
                            <Typography variant='caption'>{!!formik.values.speakerCertificate ? 'Certificado de palestrantes cadastrado' : 'Opcional'}</Typography>
                            {(speakerCertificateFile || formik.values.speakerCertificate) && (
                                <Button size="small" variant="text" onClick={() => {
                                    const file = speakerCertificateFile || (typeof formik.values.speakerCertificate === 'object' ? formik.values.speakerCertificate : null);
                                    if (file) openPreview(file, 'Pré-visualização do Certificado de Palestrantes');
                                }}>
                                    Visualizar certificado
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type={"date"}
                                id="start_subscription"
                                name="start_subscription"
                                focused
                                sx={{ width: '100%' }}
                                value={formik.values.start_subscription}
                                label="Ínicio das inscrições"
                                onChange={formik.handleChange}
                                error={formik.touched.start_subscription && Boolean(formik.errors.start_subscription)}
                                helperText={formik.touched.start_subscription && formik.errors.start_subscription}
                                variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type={"date"}
                                name="end_subscription"
                                id="end_subscription"
                                focused
                                sx={{ width: '100%' }}
                                value={formik.values.end_subscription}
                                onChange={formik.handleChange}
                                error={formik.touched.end_subscription && Boolean(formik.errors.end_subscription)}
                                helperText={formik.touched.end_subscription && formik.errors.end_subscription}
                                label="Encerramento das inscrições"
                                variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                            <Box sx={{ m: 1, position: 'relative' }}>
                                <FormGroup>
                                    <FormControl sx={{ minWidth: 240 }}>
                                        <InputLabel id="typeForm-label">Tipo de Formulário</InputLabel>
                                        <Select
                                            labelId="typeForm-label"
                                            id="typeForm"
                                            name="typeForm"
                                            value={formik.values.typeForm || 'company'}
                                            label="Tipo de Formulário"
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value="subscriber">Inscrito</MenuItem>
                                            <MenuItem value="company">Empresa</MenuItem>
                                            <MenuItem value="auto">Automático</MenuItem>
                                        </Select>
                                    </FormControl>
                                </FormGroup>
                                <Typography variant='caption' color={"#FF0000"}>{formik.touched.typeForm && formik.errors.typeForm}</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box sx={{ m: 1, position: 'relative' }}>
                                <Button variant="contained" component="label" fullWidth disabled={loadingImage}>
                                    Imagem do Evento
                                    <input
                                        hidden
                                        name="thumbnail"
                                        type={'file'}
                                        accept="image/*"
                                        label="Thumbnail"
                                        onChange={(e) => handleCertificate(e, 'img')}
                                        error={formik.touched.thumbnail && Boolean(formik.errors.thumbnail)}
                                        helperText={formik.touched.thumbnail && formik.errors.thumbnail}
                                        sx={{ width: '100%' }}
                                        variant="outlined"
                                    />
                                </Button>
                                {loadingImage && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: green[500],
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                )}
                            </Box>
                            <Typography variant='caption'>{!!formik.values.thumbnail ? 'Imagem Cadastrada' : ''}</Typography>
                            {(thumbnailFile || formik.values.thumbnail) && (
                                <Button size="small" variant="text" onClick={() => {
                                    const file = thumbnailFile || (typeof formik.values.thumbnail === 'object' ? formik.values.thumbnail : null);
                                    if (file) openPreview(file, 'Pré-visualização da Imagem do Evento');
                                }}>
                                    Visualizar imagem
                                </Button>
                            )}
                            <Typography variant='caption' color={"#FF0000"}>{formik.errors.thumbnail}</Typography>
                        </Grid>
                        <Grid item xs={12} direction={'row'} sx={{ py: 5, display: 'flex', justifyContent: 'space-between' }}>
                            <FormGroup>
                                <FormControlLabel
                                    name="isActive"
                                    control={<Switch defaultChecked={formik.values.isActive} />}
                                    id="isActive"
                                    onChange={formik.handleChange}
                                    error={formik.touched.isActive && Boolean(formik.errors.isActive)}
                                    helperText={formik.touched.isActive && formik.errors.isActive}
                                    value={formik.values.isActive}
                                    label={"Evento Ativo"} />
                            </FormGroup>
                            <FormGroup>
                                <FormControlLabel
                                    name="isVisible"
                                    control={<Switch defaultChecked={formik.values.isVisible} />}
                                    id="isVisible"
                                    onChange={formik.handleChange}
                                    error={formik.touched.isVisible && Boolean(formik.errors.isVisible)}
                                    helperText={formik.touched.isVisible && formik.errors.isVisible}
                                    value={formik.values.isVisible}
                                    label={"Evento Visível"} />
                            </FormGroup>
                            <FormGroup>
                                <FormControlLabel
                                    name="isControlCompany"
                                    control={<Switch defaultChecked={formik.values.isControlCompany} />}
                                    id="isControlCompany"
                                    onChange={formik.handleChange}
                                    error={formik.touched.isControlCompany && Boolean(formik.errors.isControlCompany)}
                                    helperText={formik.touched.isControlCompany && formik.errors.isControlCompany}
                                    value={formik.values.isControlCompany}
                                    label={"Controle de Filiados/Patrocinadores"} />
                            </FormGroup>
                            <FormGroup>
                                <FormControlLabel
                                    name="isInstallments"
                                    control={<Switch checked={Boolean(formik.values.isInstallments)} />}
                                    id="isInstallments"
                                    onChange={(e) => { 
                                        console.log(e.target.checked)
                                        formik.setFieldValue('isInstallments', e.target.checked)}}
                                    value={formik.values.isInstallments}
                                    label={"Permitir Parcelamento"} />
                            </FormGroup>
                            <FormGroup>
                                <FormControlLabel
                                    name="isCourse"
                                    control={<Switch checked={Boolean(formik.values.isCourse)} />}
                                    id="isCourse"
                                    onChange={(e) => { 
                                        console.log(e.target.checked)
                                        formik.setFieldValue('isCourse', e.target.checked)}}
                                    value={formik.values.isCourse}
                                    label={"Curso"} />
                            </FormGroup>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type={"date"}
                                id="date_initial"
                                name="date_initial"
                                sx={{ width: '100%' }}
                                value={formik.values.date_initial}
                                focused
                                label="Data Inicial do Evento"
                                onChange={formik.handleChange}
                                error={formik.touched.date_initial && Boolean(formik.errors.date_initial)}
                                helperText={formik.touched.date_initial && formik.errors.date_initial}
                                variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type={"date"}
                                id="date_finish"
                                name="date_finish"
                                sx={{ width: '100%' }}
                                focused
                                value={formik.values.date_finish}
                                label="Data Final do Evento"
                                onChange={formik.handleChange}
                                error={formik.touched.date_finish && Boolean(formik.errors.date_finish)}
                                helperText={formik.touched.date_finish && formik.errors.date_finish}
                                variant="outlined" />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField sx={{ width: '100%' }}
                                label="Cidade"
                                focused
                                id='city'
                                name="city"
                                variant="outlined"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                error={formik.touched.city && Boolean(formik.errors.city)}
                                helperText={formik.touched.city && formik.errors.city}
                                placeholder="Cidade onde acontecerá Evento" />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField sx={{ width: '100%' }}
                                label="Estado (UF)"
                                id='uf'
                                name="uf"
                                focused
                                variant="outlined"
                                inputProps={{ maxLength: 2, style: { textTransform: "uppercase" } }}
                                value={formik.values.uf}
                                onChange={formik.handleChange}
                                error={formik.touched.uf && Boolean(formik.errors.uf)}
                                helperText={formik.touched.uf && formik.errors.uf}
                                placeholder="UF" />
                        </Grid>

                        {(basePath == 'agip' || basePath == 'semper') && <Grid item xs={9} direction={'row'}>
                            <Typography variant='h5'>Contole de Formas de Pagamento:</Typography>
                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                {!!formik.values.payment_options &&
                                    Object.entries(formik.values.payment_options).map((types, index) => {
                                        const labelId = `checkbox-list-label-${types[1]}`;
                                        const status = types[1]
                                        return (
                                            <ListItem
                                                key={index}
                                                disablePadding
                                                action={() => formik.setFieldValue(`payment_options.${types[0]}`, !status)}
                                            >
                                                <ListItemButton dense>
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            onClick={() => formik.setFieldValue(`payment_options.${types[0]}`, !status)}
                                                            edge="start"
                                                            checked={status}
                                                            inputProps={{ 'aria-labelledby': labelId, "aria-controls": labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={labelId} primary={`${types[0]}`} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                            </List>
                        </Grid>
                        }
                        <Grid item xs={2} >
                            <TextField sx={{ width: '100%' }}
                                label="Vencimento do Boleto em dias:"
                                type="number"
                                name='due_date'
                                focused
                                value={formik.values.due_date}
                                onChange={(e) => {
                                    const value = e.target.value === '' ? '' : Math.max(2, Math.min(30, Number(e.target.value)));
                                    formik.setFieldValue('due_date', value);
                                }}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: format(new Date(), 'yyyy-MM-dd') }}
                                error={formik.touched.due_date && Boolean(formik.errors.due_date)}
                                helperText={formik.touched.due_date && formik.errors.due_date}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} />
                        <Grid item xs={3} >
                            <TextField sx={{ width: '100%' }}
                                label="Nome da Hospedagem"
                                id='name_hosting'
                                variant="outlined"
                                value={hosting_name.current}
                                onChange={(e) => hosting_name.current = e.target.value}
                                placeholder="Nome da Hospedagem" />
                        </Grid>
                        <Grid item xs={3} >
                            <FormControl fullWidth>
                                <InputLabel>Tipo de Hospedagem:</InputLabel>
                                <Select
                                    inputProps={{ "aria-label": "Tipo de Hospedagem" }}
                                    focused
                                    sx={{ width: '100%' }}
                                    labelId="hosting_type"
                                    id="hosting_type"
                                    value={hosting_type.current}
                                    onChange={(event) => hosting_type.current = event.target.value}
                                    label="Tipo de Hospedagem"
                                >
                                    <MenuItem value="Single">Single</MenuItem>
                                    <MenuItem value="Duplo">Duplo</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} >
                            <IntlCurrencyInput
                                currency="BRL"
                                config={currencyConfig}
                                onChange={(event, value, maskedValue) => {
                                    event.preventDefault();
                                    hosting_price.current = value
                                }
                                }
                                label="Valor"
                                sx={{ width: '100%' }}
                                name="price"
                                id="hosting_price"
                                defaultValue={0}
                                variant="outlined"
                                placeholder="R$ 0,00"
                                component={TextField}
                            />
                        </Grid>
                        <Grid item xs={2} >
                            <TextField
                                inputProps={{ "aria-label": "Quantidade de Vagas" }}
                                variant="outlined"
                                sx={{ width: '100%' }}
                                labelId="hosting_vacancies"
                                id="hosting_vacancies"
                                type='number'
                                value={hosting_vacancies.current}
                                onChange={(event) => hosting_vacancies.current = event.target.value}
                                label="Quantidade de Vagas"

                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button fullWidth variant="contained" color='info' style={{ minHeight: '54px' }} onClick={addHostings} startIcon={<Add />} >
                                Adicionar Hospedagem
                            </Button>
                        </Grid>
                        <Grid item xs={12} direction={'row'} >
                            <Grid direction={'row'}  >
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    {insertHostings.map((types, index) => {
                                        const labelId = `checkbox-list-label-${index}`;
                                        const vagasRestantes = formik.values.counter_hostings[types.id] ? types.attributes.vacancies - formik.values.counter_hostings[types.id] : types.attributes.vacancies;
                                        return (
                                            <ListItem
                                                key={index}
                                                secondaryAction={
                                                    <>
                                                        <IconButton edge="end" aria-label="actions" onClick={() => handleDeleteHosting(types.id)}>
                                                            <DeleteIcon color='error' />
                                                        </IconButton>

                                                    </>
                                                }
                                                disablePadding
                                            >
                                                <ListItemButton role={undefined} dense onClick={() => handleEditVagas(types, formik.values.counter_hostings[types.id])}>
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            onClick={() => handelStatusHosting(types.id)}
                                                            edge="start"
                                                            checked={types.attributes.status}
                                                            inputProps={{ 'aria-labelledby': labelId, "aria-controls": labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={labelId} primary={`${types.attributes.name} | ${types.attributes.type} | ${Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(types.attributes.pricebyday)} | ${types.attributes.vacancies} Vagas | Restantes: ${vagasRestantes}`} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} />
                        <Grid item xs={3} >
                            <TextField sx={{ width: '100%' }}
                                label="Data/Hora de inicio da coleta"
                                type={"datetime-local"}
                                focused
                                name='collect_start'
                                onChange={(e) => collect_start.current = e.target.value}
                            />
                        </Grid>
                        <Grid item xs={3} >
                            <TextField sx={{ width: '100%' }}
                                label="Data/Hora de final da coleta"
                                type={"datetime-local"}
                                focused
                                name='collect_finish'
                                onChange={(e) => collect_finish.current = e.target.value}
                            />
                        </Grid>
                        <Grid item xs={2} >
                            <TextField sx={{ width: '100%' }}
                                label="Crédito minimo em horas"
                                type="number"
                                name='credit'
                                onChange={(e) => credit.current = e.target.value}
                                focused
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Button fullWidth variant="contained" color='warning' style={{ minHeight: '54px' }} onClick={addCollectors} startIcon={<Add />} >
                                adicionar referência de coleta
                            </Button>
                        </Grid>
                        <Grid item xs={12} direction={'row'} >
                            <Grid direction={'row'}  >
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    {insertCollectors.map((collect, index) => {
                                        const labelId = `checkbox-list-label-${index}`;
                                        return (
                                            <ListItem
                                                key={index}
                                                secondaryAction={
                                                    <IconButton edge="end" aria-label="actions" onClick={() => handelDeleteCollect(collect.id)}>
                                                        <DeleteIcon color='error' />
                                                    </IconButton>
                                                }
                                                disablePadding
                                            >
                                                <ListItemButton role={undefined} dense >
                                                    <ListItemText id={labelId} primary={`Inicia: ${format(parseISO(collect.attributes.collect_start), "dd/MM/yy HH:mm")} Encerra: ${format(parseISO(collect.attributes.collect_finish), "dd/MM/yy HH:mm")} Crédito: ${collect.attributes.credit}h`} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='caption' color={"#FF0000"}>{formik.errors.collectors}</Typography>
                        </Grid>
                        <Grid item xs={6} >
                            <Autocomplete
                                disablePortal
                                id="combo-box-types"
                                fullWidth
                                freeSolo
                                placeholder="Tipo"
                                name="type"
                                onChange={(event, newInputValue) => {
                                    typechange.current = newInputValue
                                }}
                                onInputChange={(event, newInputValue) => {
                                    typechange.current = newInputValue
                                }}
                                options={listTypes}
                                renderInput={(params) =>
                                    <TextField sx={{ width: '100%' }}
                                        {...params}
                                        label="Tipo"
                                        ariant="outlined"
                                    />}
                            />
                        </Grid>
                        <Grid item xs={2} >
                            <IntlCurrencyInput
                                currency="BRL"
                                config={currencyConfig}
                                onChange={(event, value, maskedValue) => {
                                    event.preventDefault();
                                    pricechange.current = value
                                }
                                }
                                label="Valor"
                                sx={{ width: '100%' }}
                                name="price"
                                defaultValue={0}
                                variant="outlined"
                                placeholder="R$ 0,00"
                                component={TextField}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="Data de vencimento do boleto"
                                type="date"
                                value={newPlanDueDate}
                                helperText="Em branco, usa o vencimento definido no evento."
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: format(new Date(), 'yyyy-MM-dd') }}
                                onChange={(event) => {
                                    setNewPlanDueDate(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button fullWidth variant="contained" onClick={addTypes} startIcon={<Add />} >
                                Adicionar tipo de inscrição
                            </Button>
                        </Grid>
                        <Grid item xs={12} direction={'row'} >
                            <Grid direction={'row'}  >
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    {insertTypes.map((types, index) => {
                                        const labelId = `checkbox-list-label-${index}`;
                                        let type = types.type !== undefined ? types.type : types.attributes.type
                                        let price = types.price !== undefined ? types.price : types.attributes.price
                                        let status = types.status !== undefined ? types.status : types.attributes.status
                                        return (
                                            <ListItem
                                                key={index}
                                                //onClick={() => handelStatusPlan(types.id)}
                                                secondaryAction={
                                                    <>
                                                        <IconButton edge="end" aria-label="actions" onClick={() => handleChangeTypesName(types)}>
                                                            <Edit color='warning' />
                                                        </IconButton>
                                                        <IconButton edge="end" aria-label="actions" onClick={() => handelDeleteType(types.id)}>
                                                            <DeleteIcon color='error' />
                                                        </IconButton>

                                                    </>
                                                }
                                                disablePadding
                                            >
                                                <ListItemButton dense>
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            onClick={() => handelStatusPlan(types.id)}
                                                            edge="start"
                                                            checked={status}
                                                            inputProps={{ 'aria-labelledby': labelId, "aria-controls": labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={index + 2} primary={`${type} - ${Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(types.attributes.price)}`} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </Grid>
                        </Grid>
                        <Typography variant='caption' color={"#FF0000"}>{formik.errors.plans}</Typography>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            color='error'
                            variant="contained"
                            onClick={() => handleBack()}
                            sx={{ mt: 3, ml: 1 }}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                console.log('Formik errors:', formik.errors);
                                formik.handleSubmit();
                            }}
                            sx={{ mt: 3, ml: 1 }}>
                            Próximo
                        </Button>
                        <Button
                            variant="contained"
                            color='success'
                            onClick={() => handleInformation()}
                            sx={{ mt: 3, ml: 1 }}>
                            Atualizar Evento
                        </Button>
                        <Dialog
                            open={previewOpen}
                            onClose={closePreview}
                            maxWidth="lg"
                            fullWidth
                        >
                            <DialogTitle>{previewTitle}</DialogTitle>
                            <DialogContent>
                                {previewUrl && (
                                    <img src={previewUrl} alt={previewTitle} style={{ width: '100%', maxHeight: '70vh', objectFit: 'contain' }} />
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={closePreview}>Fechar</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog xs={12}
                            open={planDialog}
                            fullWidth={true}
                            maxWidth="lg"
                            onClose={() => setplanDialog(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">Alterar Tipo de Inscrição</DialogTitle>
                            <DialogContent sx={{ width: '100%' }}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    type='text'
                                    label="Plano"
                                    focused
                                    id='alert-dialog-description'
                                    name='Plano'
                                    defaultValue={planName.current}
                                    onChange={(e) => planName.current = e.target.value}
                                    variant="outlined"
                                    placeholder="Nome do Evento" />
                                <TextField
                                    sx={{ width: '100%', mt: 2 }}
                                    label="Data de vencimento do boleto"
                                    type="date"
                                    helperText="Em branco, usa o vencimento definido no evento."
                                    InputLabelProps={{ shrink: true }}
                                inputProps={{ min: format(new Date(), 'yyyy-MM-dd') }}
                                    defaultValue={planChange.current?.attributes?.dueDate ?? ''}
                                    onChange={(event) => {
                                        planDueDateChange.current = event.target.value
                                    }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    color="warning"
                                    onClick={() => {
                                        planName.current = "";
                                        setplanDialog(false);
                                    }
                                    }>Cancelar</Button>
                                <Button autoFocus onClick={() => updatePlan(planName.current)} color="success">
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </Box>
            </form>
            <Dialog
                open={editVagasDialog}
                onClose={() => setEditVagasDialog(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Editar Hotel</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ padding: 2 }}>
                        <Grid item xs={12}>
                            <TextField
                                label="Nome Hospedagem "
                                type="text"
                                value={hostingEdit?.attributes.name || ''}
                                onChange={e => setHostingEdit({ ...hostingEdit, attributes: { ...hostingEdit.attributes, name: e.target.value } })}
                                fullWidth
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={10}>
                            <TextField
                                label="Vagas"
                                type="number"
                                value={hostingEdit?.attributes.vacancies}
                                onChange={e => {
                                    setHostingEdit({ ...hostingEdit, attributes: { ...hostingEdit.attributes, vacancies: e.target.value } })
                                }
                                }
                                fullWidth
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label="Vagas Restantes"
                                type="number"
                                value={hostingEdit?.attributes.vacancies - vagasEditValue}
                                disabled
                                fullWidth
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <IntlCurrencyInput
                                currency="BRL"
                                config={currencyConfig}
                                onChange={(event, value, maskedValue) => {
                                    event.preventDefault();
                                    setHostingEdit({ ...hostingEdit, attributes: { ...hostingEdit.attributes, pricebyday: value } });
                                }
                                }
                                disabled
                                label="Valor"
                                sx={{ width: '100%' }}
                                defaultValue={hostingEdit?.attributes.pricebyday || 0}
                                variant="outlined"
                                placeholder="R$ 0,00"
                                component={TextField}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setEditVagasDialog(false)
                        setHostingEdit(null);
                        setVagasEditValue(0);

                    }
                    } color="inherit">Cancelar</Button>
                    <Button
                        onClick={() => handleUpdateHosting()}
                        color="success"
                        variant="contained"
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default Information;
